<template>
  <div>
    <Navbar type="bg-transparent-sticky" />
    <div class="hero-container-thin">
      <div class="hero-opacity" />
      <img class="hero-image" src="../assets/gdq_hero.jpg" alt="hero image" />
    </div>
    <Breadcrumb />
    <div class="container-xl" style="position:relative !important;">
      <!-- Loading Overlay -->
      <div v-if="loading" class="loading-overlay d-flex justify-content-center mb-3">
        <b-spinner label="Loading..."></b-spinner>
      </div>
      <div class="text-container">
        <div class="title-area">
            <h1 class="page-title">
                <span
                  :class="`${anon ? 'g-anon' : '' }`"
                >
                  {{ survey.survey_name }}:
                </span>
                {{ screentexts[154]?screentexts[154].element_text:'Invitation' }}
                <!-- <PopupBubble
                  v-if="screentexts[154] && screentexts[154].element_bubbletext != '' && screentexts[154].element_bubbletext !== null"
                  screenelement_id="154"
                  :screen_id="screen_id"
                  :bubbletext="screentexts[154]?screentexts[154].element_bubbletext:''"
                /> -->
            </h1>
        </div>
        <b-form-group :label="screentexts[157]?screentexts[157].element_text:'Invitation e-mail Subject Line'">
          <b-form-input
            v-model="survey.survey_invitation_subject"
            :placeholder="screentexts[158]?screentexts[158].element_text:'Enter the subject of the invitation e-mail'"
          />
        </b-form-group>
        <b-form-group
          v-if="survey.spotify!=1"
          :label="screentexts[155]?screentexts[155].element_text:'Invitation e-mail fixed text'"
        >
          <div
            id="fixed-text"
            class="mt-3"
            v-html="survey.survey_invitation_text"
          />
        </b-form-group>
        <div class="d-flex justify-content-end mb-4">
          <b-button @click="copyText" class="btn-small">
            Copy Text
          </b-button>
        </div>
        <b-form-group
          :label="screentexts[156]?screentexts[156].element_text:'Invitation e-mail personal text'"
        >
          <vue-editor
            v-model="survey.survey_invitation_consultant_text"
            :class="`${anon ? 'g-anon' : '' }`"
            :editor-toolbar="editortoolbar"
            :placeholder="'Personal text'"
          />
        </b-form-group>
        <div class="buttons-navigation mt-5">
          <b-link
            to="/create/group/survey/details"
            class="float-left"
          >
            <b-button variant="secondary">
              &lt; Back
            </b-button>
          </b-link>
          <b-link
            to="/create/group/survey/dates"
            class="float-right"
          >
            <b-button variant="primary">
              Next >
            </b-button>
          </b-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Navbar from './Navbar.vue'
import Breadcrumb from './Breadcrumb.vue'
import { VueEditor } from 'vue2-editor'
import PopupBubble from './PopupBubble.vue'

var editortools = [
  []
]

export default {
  name: 'CreateGroupSurveyEmailSettings',
  components: {
    Navbar,
    Breadcrumb,
    VueEditor
    // PopupBubble,
  },
  data () {
    return {
      editortoolbar: editortools,
      group_name: this.$store.state.currentgroup.group_name,
      survey: this.$store.state.currentsurvey,
      screen_id: 10,
      screentexts: [],
      loading: false
    }
  },
  computed: {
    anon: function () {
      return this.$store.state.anon
    },
    survey_id () {
      return this.$store.state.currentsurvey_id
    }
  },
  async created () {
    this.loading = true
    await this.screentexts_get()
    await this.survey_get()
    this.loading = false
  },
  async beforeRouteLeave (to, from, next) {
    // ---------------------------------------------------------------------------
    // We are going forward - save, I wonder should I change "create" to "save" ?
    // ---------------------------------------------------------------------------
    if (to.name == 'creategroupsurveydates') {
      await this.groupsurvey_save()
    }
    next()
  },
  methods: {
    parse_email (email) {
      // eslint-disable-next-line
      const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;   
      return pattern.test(email.toLowerCase())
    },
    survey_get: async function () {
      await this.$store.dispatch('groupsurvey_fetch', { id: this.survey_id })
        .then((resp) => {
          this.survey = resp.data
        })
    },
    screentexts_get: async function () {
      var screentexts = []
      var filter = {
        screen_id: {
          operator: '=',
          value: this.screen_id
        }
      }
      await this.$store.dispatch('systemscreenelements_fetch', { filter: filter })
        .then((resp) => {
          var dbtexts = resp.data.result
          for (var i = 0; i < dbtexts.length; i++) {
            var screentext = {
              id: dbtexts[i].id,
              element_text: dbtexts[i].element_text,
              element_bubbletext: dbtexts[i].element_bubbletext
            }
            screentexts[dbtexts[i].id] = screentext
          }
          this.screentexts = screentexts
        })
    },
    copyText () {
      const editorContent = document.querySelector('#fixed-text')
      const range = document.createRange()
      range.selectNodeContents(editorContent)
      const selection = window.getSelection()
      selection.removeAllRanges()
      selection.addRange(range)
      document.execCommand('copy')
      selection.removeAllRanges()
    },
    async groupsurvey_save () {
      // this.survey.survey_invitation_subject = this.survey.survey_invitation_subject
      // this.survey.survey_invitation_text = this.survey.survey_invitation_text
      // this.survey.survey_invitation_consultant_text = this.survey.survey_invitation_consultant_text
      //      survey.survey_invitation_cc = this.survey_invitation_cc;
      await this.$store.dispatch('groupsurvey_save', { survey: this.survey })
    }
  }
}
</script>
<style scoped>
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8); /* Semi-transparent background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
</style>
